import { render } from "./PageTitle.vue?vue&type=template&id=10315364&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=10315364&scoped=true&lang=scss"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10315364"]])

export default __exports__